import { useMutation } from '@tanstack/react-query'
import { useAuth } from './useAuth'
import type { AddUserFeedback } from '../types/types'
import { throwOnError } from '../utils/throwOnError'

export const useCreateUserFeedback = () => {
  const { authFetch } = useAuth()
  return useMutation({
    mutationFn: async (feedback: AddUserFeedback) => {
      const { data, error } = await authFetch().POST('/userfeedback', {
        body: feedback
      })
      if (error) {
        throwOnError(error)
      }
      return data
    }
  })
}
